export default __webpack_public_path__ + "static/media/1855.2350b04c.png";